import React from "react";
import PropTypes from "prop-types";
import { MarkdownGenerator } from "./../Blocks.js";
import { css } from "styled-components";

const Markdown = MarkdownGenerator({
  style: css`
    pre {
      line-height: 1.75 !important;
      white-space: pre-line;
    }
  `,
});

const Content = (props, context) => {
  const copy = context.copy.get("Impressum");

  return (
    <div className="content px2">
      <h1 className="h3 mb3">{copy && copy.Title}</h1>
      <Markdown>{copy && copy.Content}</Markdown>
    </div>
  );
};
Content.contextTypes = { copy: PropTypes.object };

export default Content;



// WEBPACK FOOTER //
// ./src/Legal/Content.js